import { ROLES, type RoleStrategy } from "@pharmupp/p3-front-commons"
import { ManagementEnum } from "./Management.schema"

export const formRoleConf = {
  [ROLES.ADMIN]: {},
  [ROLES.ADHERENT_HOLDER]: {},
  [ROLES.ADHERENT_TEAM]: {
    [ManagementEnum.LGO]: { disabled: true },
  },
} satisfies RoleStrategy<Record<string, { disabled: boolean }>>
